'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () {
                        return e[k];
                    }
                });
            }
        });
    }
    n['default'] = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

const Svg12 = (props) => (React__namespace.createElement("svg", Object.assign({ width: 12, height: 13, viewBox: "0 0 12 13", fill: "none" }, props),
    React__namespace.createElement("g", { clipPath: "url(#12_svg__clip0_39877_64169)" },
        React__namespace.createElement("path", { d: "M1.21396 2.2108C1.56544 1.85933 2.13529 1.85934 2.48675 2.21082L6.00054 5.7247L9.51429 2.21085C9.86576 1.85938 10.4356 1.85937 10.7871 2.21084C11.1386 2.56231 11.1386 3.13215 10.7871 3.48363L7.27332 6.9975L10.7869 10.5112C11.1384 10.8627 11.1384 11.4325 10.7869 11.784C10.4354 12.1354 9.86557 12.1354 9.5141 11.784L6.00054 8.27031L2.48694 11.784C2.13548 12.1355 1.56563 12.1355 1.21415 11.784C0.862675 11.4326 0.862667 10.8627 1.21413 10.5112L4.72776 6.9975L1.21394 3.48359C0.862476 3.13212 0.862484 2.56227 1.21396 2.2108Z", fill: props.fillColor, fillOpacity: 0.92 })),
    React__namespace.createElement("defs", null,
        React__namespace.createElement("clipPath", { id: "12_svg__clip0_39877_64169" },
            React__namespace.createElement("rect", { width: 12, height: 12, fill: "white", transform: "translate(0 0.997681)" })))));

exports.default = Svg12;
//# sourceMappingURL=12.js.map
